const isStringEqual = (x, y) => {
    if (x && y) {
        return x.localeCompare(y, undefined, { sensitivity: 'accent' }) == 0;
    }
    return x == y;
};
const isArrayEqual = (x, y, isItemEqual) => {
    if (!x && !y) {
        return true;
    }
    if (!x || !y || x.length != y.length) {
        return false;
    }
    const isEqual = isItemEqual ? isItemEqual : (a, b) => a == b;
    for (let i = 0; i < x.length; i++) {
        if (!isEqual(x[i], y[i])) {
            return false;
        }
    }
    return true;
};
const isCountryEqual = (x, y) => (!x && !y) || (isStringEqual(x?.code, y?.code) && isStringEqual(x?.name, y?.name));
const isAddressItemEqual = (x, y) => (!x && !y) ||
    (isStringEqual(x?.name, y?.name) &&
        isStringEqual(x?.abbreviation, y?.abbreviation) &&
        isStringEqual(x?.fiasId, y?.fiasId));
const isHousePartEqual = (x, y) => (!x && !y) || (isStringEqual(x?.number, y?.number) && isStringEqual(x?.type, y?.type));
const isHouseEqual = (x, y) => (!x && !y) ||
    (isStringEqual(x?.name, y?.name) &&
        isStringEqual(x?.fiasId, y?.fiasId) &&
        isArrayEqual(x?.parts, y?.parts, isHousePartEqual));
const isFlatEqual = (x, y) => (!x && !y) ||
    (isStringEqual(x?.number, y?.number) && isStringEqual(x?.type, y?.type) && isStringEqual(x?.fiasId, y?.fiasId));
const isRoomEqual = (x, y) => (!x && !y) ||
    (isStringEqual(x?.number, y?.number) && isStringEqual(x?.type, y?.type) && isStringEqual(x?.fiasId, y?.fiasId));
export const isAddressEqual = (x, y) => (!x && !y) ||
    (isCountryEqual(x?.country, y?.country) &&
        isAddressItemEqual(x?.region, y?.region) &&
        isAddressItemEqual(x?.municipalDistrict, y?.municipalDistrict) &&
        isAddressItemEqual(x?.district, y?.district) &&
        isAddressItemEqual(x?.city, y?.city) &&
        isAddressItemEqual(x?.intracityArea, y?.intracityArea) &&
        isAddressItemEqual(x?.urbanSettlement, y?.urbanSettlement) &&
        isAddressItemEqual(x?.settlement, y?.settlement) &&
        isAddressItemEqual(x?.planningStructure, y?.planningStructure) &&
        isAddressItemEqual(x?.street, y?.street) &&
        isAddressItemEqual(x?.stead, y?.stead) &&
        isHouseEqual(x?.house, y?.house) &&
        isFlatEqual(x?.flat, y?.flat) &&
        isRoomEqual(x?.room, y?.room) &&
        isStringEqual(x?.text, y?.text) &&
        isStringEqual(x?.residenceDate, y?.residenceDate) &&
        isStringEqual(x?.postalCode, y?.postalCode));
